import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import {
    deleteCar,
    editCar,
    editCarPro,
    getCar,
    getCarList,
    updateCar,
} from '../sellThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'sellCar';

export const sellCarSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarList });
        handleRequestThunk({ builder, request: getCar });
        handleRequestThunk({ builder, request: deleteCar, isDelete: true });
        handleRequestThunk({ builder, request: editCar });
        handleRequestThunk({ builder, request: editCarPro });
        handleRequestThunk({ builder, request: updateCar });
    },
});

export const sellCar = sellCarSlice.reducer;
